let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("SyZiC")).then(() => parcelRequire('d47cs'));